import { orderBy } from "lodash"

class PartDetailController {
  constructor(userProfile, $state, $scope) {
    this.userProfile = userProfile
    this.$state = $state

    $scope.$on('partPriceChanged', (event, part) => {
      this.part.UnitPrice = part.UnitPrice
    })
  }

  $onInit() {
    this.part.ImageFiles.forEach(file => {
      file.DisplayUrl = `${file.Url}?ForDownload=false`
    })
  }

  hasPermission(permission) {
    return this.userProfile.hasPermission(permission)
  }

  edit() {
    this.$state.go('^.edit', {
      partId: this.part.Id,
      part: this.part
    })
  }

  getLastOrderCost(partOrderItems) {
    partOrderItems = partOrderItems || [];
    const lastOrder = orderBy(partOrderItems, (oi) => oi.PartOrderOrderDate, "desc").at(
      0
    ) || {};
    return lastOrder.UnitCost;
  }
}
PartDetailController.$inject = ['userProfile', '$state', '$scope']

export default PartDetailController
